module.exports = __webpack_public_path__ + "static/img/guan-top.59b2901.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guan-top.png
// module id = 0uek
// module chunks = 0